export default {
    name: 'page',

    hooks: {
        app: {
            init() {
                this.page.elMainOverlay =
                    document.getElementById('main-overlay');
                this.page.elMainSpinner =
                    document.getElementById('main-spinner');
                return 'complete';
            },

            loadAppData(data, registry) {
                if (registry.MixinLocale === 'complete') {
                    // If a page exists in response.
                    if (data.page) {
                        if (data.page.instance) {
                            data.page.instance.loadData({
                                vars: data.vars,
                                trans: data.trans,
                            });
                        } else {
                            this.page.create(data.page);
                        }
                    }
                    return 'complete';
                }
                return 'wait';
            },
        },
    },

    methods: {
        app: {
            pages: {},

            create(data) {
                try {
                    let classDefinition =
                        window.pageCurrent ||
                        this.getClassDefinition(
                            'pages',
                            this.getClassPage(),
                            data.name
                        );

                    data.instance = new classDefinition(this, data);

                    return data.instance;
                } catch (e) {
                    console.error(e);
                    this.system.error('Error during page creation.');
                }
            },

            loadingStart() {
                this.page.elMainOverlay.classList.add('visible');
                this.page.elMainSpinner.classList.add('visible');
            },

            loadingStop() {
                this.page.elMainOverlay.classList.remove('visible');
                this.page.elMainSpinner.classList.remove('visible');
            },
        },
    },
};
